import { assignTokens } from '@sail/engine';
import { copyTokens } from './tokens';
import { helmTokens, COLUMN_PADDING_SIZES } from '../../theme';
// Create columnPadding variants based on the columnPadding tokens
const createPaddingVariant = (direction)=>{
    return COLUMN_PADDING_SIZES.reduce((acc, size)=>{
        acc[size] = {
            uses: [
                assignTokens(copyTokens, {
                    [`columnPadding${direction}`]: `${helmTokens.layout.columnPadding[size]}`
                })
            ]
        };
        return acc;
    }, {});
};
export const columnPaddingVariants = {
    columnPaddingLeft: createPaddingVariant('Left'),
    columnPaddingRight: createPaddingVariant('Right')
};

//# sourceMappingURL=ColumnPaddingVariants.js.map